import Patch from "@shared/models/patch-updater"

export default {
  PRINT_CONFIGURATOR_SET_OPTION: {
    params: {
      sessionId: "string",
      componentId: "string",
      option: "string",
      value: { type: ["string", "boolean", "number"] },
    },
    patches(payload) {
      let patch = Patch.create("app-state", payload.sessionId).set(
        "attributes." + payload.componentId + ".settings.options." + payload.option,
        payload.value
      )

      if (payload.option === "filterClasses") {
        patch.set(
          "attributes." + payload.componentId + ".settings.options.lineUpClasses",
          payload.value
        )
      }

      return [patch.patch]
    },
  },

  PRINT_CONFIGURATOR_SET_LAYOUT: {
    params: {
      sessionId: "string",
      componentId: "string",
      layout: "string",
    },
    patches(payload) {
      let patch = Patch.create("app-state", payload.sessionId).set(
        "attributes." + payload.componentId + ".settings.layout",
        payload.layout
      ).patch

      return [patch]
    },
  },

  PRINT_CONFIGURATOR_SET_FILE_NAME: {
    params: {
      sessionId: "string",
      componentId: "string",
      fileName: "string",
    },
    patches(payload) {
      let patch = Patch.create("app-state", payload.sessionId).set(
        "attributes." + payload.componentId + ".settings.output.fileName",
        payload.fileName
      ).patch

      return [patch]
    },
  },

  PRINT_CONFIGURATOR_ADD_COURSE_ID: {
    params: {
      sessionId: "string",
      componentId: "string",
      courseId: "string",
    },
    patches(payload) {
      let patch = Patch.create("app-state", payload.sessionId).addToSet(
        "attributes." + payload.componentId + ".settings.model.courseIds",
        payload.courseId
      ).patch

      return [patch]
    },
  },

  PRINT_CONFIGURATOR_REMOVE_COURSE_ID: {
    params: {
      sessionId: "string",
      componentId: "string",
      courseId: "string",
    },
    patches(payload) {
      let patch = Patch.create("app-state", payload.sessionId).pull(
        "attributes." + payload.componentId + ".settings.model.courseIds",
        payload.courseId
      ).patch

      return [patch]
    },
  },

  PRINT_CONFIGURATOR_SET_MEDIUM: {
    params: {
      sessionId: "string",
      componentId: "string",
      medium: "string",
    },
    patches(payload) {
      let patch = Patch.create("app-state", payload.sessionId).set(
        "attributes." + payload.componentId + ".settings.output.medium",
        payload.medium
      ).patch

      return [patch]
    },
  },
}
